import dashboardPageDirective from './DashboardPageDirective'
import angular from 'angular';
import uiRouter from '@uirouter/angularjs';
import angularGettext from 'angular-gettext';

import buttonsDemo from './buttonsDemo/buttonsDemo'
import summaryDemoModule from './summaryDemoPanels/summaryDemo';
import mediaPickerDemo from './mediaPickingDemoPanel/mediaPickerDemoPanel';
import subscribeStats from '../Mails/SubscribeStatsChart/SubscribeStatsChart';
import pieChart from '../../cmsCore/Chart/PieChart/pieChart';

import './dashboard.scss';

let dashboardModule = angular.module('cms.pages.dashboard', [
    uiRouter,
    dashboardPageDirective,
    buttonsDemo,
    summaryDemoModule,
    angularGettext,
    mediaPickerDemo,
    subscribeStats,
    pieChart,
])
    .config(routeConfig);

function routeConfig($stateProvider,gettext) {
    /** @ngInject */

    $stateProvider
        .state('dashboard', {
            url: '/',
            component: 'appDashboard',
            title: gettext('Dashboard'),
            data: {
                requiresAuth: ['ROLE_ADMIN', 'ROLE_USER']
            },
            sidebarMeta: {
                icon: 'ion-android-home',
                order: 0,
                allow: ['ROLE_ADMIN', 'ROLE_USER']
            },
            breadcrumbsMeta: {
                topBar: false
            }
        });
}


export default dashboardModule.name;


// WEBPACK FOOTER //
// ./src/cmsPages/Dashboard/Dashboard.js